import React, { useEffect, useRef, useState } from 'react';

import '../../../index.css';
import '../../../font.css';
import VideoPlayer from '../../../components/VideoPlayer';
import ImageSlider from '../../../components/ImageSlider';
import ProductSlider from '../../../components/ProductSlider';
import {
  insertContentsTimeLog,
  insertItemLog,
  insertMakeShopItemLog,
  insertSlideLog,
} from '../../../modules/NetworkFunction';

// 모바일 버전 콘텐츠 미리보기 (팝업 세로)
function ContentsPreviewMobile({
  videoUrl,
  slideList,
  btnColor,
  fontColor,
  font,
  btnBorderRadius,
  contentsStyle,
  detailPath,
  contentNo,
  margin,
  shopMode,
  isWebpack = false,
  isPopup
}) {
  const [currentSlideIdx, setCurrentSlideIdx] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [playing, setPlaying] = useState(true);
  const [imageSlider, setImageSlider] = useState();
  const [productSlider, setProductSlider] = useState();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const timerId = useRef();
  const playerRef = useRef();
  const sliderRef = useRef();
  const btnRef = useRef();

  console.log('isWebpack : ', isWebpack);
  console.log('contentsStyle: ', contentsStyle)
  console.log('isPopup: ', isPopup)

  useEffect(() => {
    console.log(contentsStyle);
    if (btnRef.current) {
      btnRef.current.style.setProperty('font-family', font, 'important');
    }
  }, [font]);

  useEffect(() => {
    timerId.current = setInterval(async () => {
      if (playing) {
        const time = await playerRef.current.getCurrentTime();
        setCurrentTime(Number.parseInt(time));

        if (time != null && contentNo) {
          let params = `?contentsNo=${contentNo}&startTime=${time}`;
          insertContentsTimeLog(params);
        }
      }
    }, 1000);

    return () => {
      clearInterval(timerId.current);
    };
  }, [playerRef, playing, timerId, contentNo]);

  useEffect(() => {
    const checkPlayer = () => {
      const time = currentTime;

      for (let i = 0; i < slideList.length; i++) {
        if (slideList[i].displayTime > time) {
          let index = i < 1 ? 0 : i - 1;
          setCurrentSlideIdx(index);
          break;
        } else if (i === slideList.length - 1) {
          setCurrentSlideIdx(i);
        }
      }
    };
    checkPlayer();
  }, [currentTime, slideList]);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.handleChangeSlideIdx(currentSlideIdx);
    }
  }, [currentSlideIdx]);

  const itemClick = (idx) => {
    _setPage(slideList[idx], idx);
  };

  const _setPage = (slideItem, index) => {
    if (index !== currentSlideIdx) {
      playerRef.current.seekTo(slideItem.displayTime);
      setCurrentSlideIdx(index);
      setPlaying(true);

      if (contentNo) {
        insertSlideLog(`?slideNo=${slideItem.slideNo}`);
      }
    }
  };

  const buyBtnClick = () => {
    console.log('contentspreview mobile buyBtn Click');
    console.log('currentSlideIdx', currentSlideIdx);
    console.log('slideList', slideList);
    console.log('slideList[currentSlideIdx]', slideList[currentSlideIdx]);
    console.log(
      'slideList[currentSlideIdx].productNo',
      slideList[currentSlideIdx].productNo
    );
    console.log('detailPath', detailPath);

    if (detailPath) {
      window.open(detailPath + slideList[currentSlideIdx].productNo, '_blank');
      if (shopMode === 'cafe24') {
        insertItemLog(
          `?slideNo=${slideList[currentSlideIdx].slideNo}&itemNo=${slideList[currentSlideIdx].itemNo}`
        );
      } else {
        insertMakeShopItemLog(
          `?slideNo=${slideList[currentSlideIdx].slideNo}&itemNo=${slideList[currentSlideIdx].itemNo}`
        );
      }
    }
  };

  // popup일 경우 체크
  const IsIncludePopup = (style) => {
    const encodedStyle = encodeURIComponent(style);
    const decodedStyle = decodeURIComponent(encodedStyle);
  
    console.log('isWebpack:', isWebpack);
    console.log('encoded style:', encodedStyle);
    console.log('decoded style:', decodedStyle);
  
    return decodedStyle.includes('popup') || decodedStyle.includes('팝업');
  }

  return (
    <div
      className={
        (IsIncludePopup(contentsStyle) || contentsStyle === 'popup_v' || contentsStyle === '팝업 세로')
          ? 'preview-popup'
          : `preview-drawer ${isDrawerOpen ? 'open' : ''}`
      }
    >
      <div
        className={`${contentNo ? 'published-' : ''}mobile-contents`}
        style={{
          margin:
            (IsIncludePopup(contentsStyle) || contentsStyle === 'popup_v' || contentsStyle === '팝업 세로') && isWebpack
              ? '70px auto'
              : `${margin}px auto`,
        }}
      >
        {isWebpack && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button
              className="btn-close"
              onClick={() =>
                document.querySelector('.preview-popup').classList.add('close')
              }
            >
              <img
                alt="닫기"
                src="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-mobile-close.png"
              />
            </button>
          </div>
        )}
        <div className="video-wrapper-vertical">
          <VideoPlayer
            ref={playerRef}
            videoUrl={videoUrl}
            playing={playing}
            setPlaying={setPlaying}
            isMobile={true}
          />
        </div>
        <div className="slide-wrapper">
          {slideList.length > 0 && (
            <ImageSlider
              slideList={slideList}
              ref={sliderRef}
              isMobile={true}
              handleSlideClick={(idx) => {
                _setPage(slideList[idx], idx);
              }}
              setSlider={setImageSlider}
              syncSlider={productSlider}
            />
          )}
        </div>

        {(IsIncludePopup(contentsStyle) || contentsStyle === 'popup_v' || contentsStyle === '팝업 세로') && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              height: '7%',
              width: '100%',
            }}
          >
            <div className="buy-button-container">
              <button
                ref={btnRef}
                className="buy-button"
                style={{
                  backgroundColor: btnColor,
                  borderRadius: btnBorderRadius,
                  color: fontColor,
                  fontFamily: font,
                }}
                onClick={buyBtnClick}
              >
                구매하기
              </button>
            </div>
          </div>
        )}
        <div className="item-container">
          <p
            style={{
              fontSize: 14,
              margin: '6px 10px',
              height: '10%',
              fontWeight: 'bold',
              fontFamily: font,
            }}
          >
            영상 속 다른 상품
          </p>
          <div style={{ display: 'flex', flexDirection: 'row', height: '75%' }}>
            <ProductSlider
              type={(IsIncludePopup(contentsStyle) || contentsStyle === 'popup_v' || contentsStyle === '팝업 세로') ? 'popup' : 'drawer'}
              isMobile={true}
              slideList={slideList}
              currentSlideIdx={currentSlideIdx}
              itemClick={itemClick}
              btnColor={btnColor}
              fontColor={fontColor}
              font={font}
              setSlider={setProductSlider}
              syncSlider={imageSlider}
            />
          </div>
        </div>
        {!(IsIncludePopup(contentsStyle) || contentsStyle === 'popup_v' || contentsStyle === '팝업 세로') && (
          <div className="drawer-bottom">
            <div
              className={`drawer-buy-button-container ${
                isDrawerOpen ? 'open' : ''
              }`}
            >
              <button
                ref={btnRef}
                className="buy-button"
                style={{
                  backgroundColor: btnColor,
                  borderRadius: btnBorderRadius,
                  color: fontColor,
                  fontFamily: font,
                }}
                onClick={buyBtnClick}
              >
                구매하기
              </button>
            </div>
            <button
              className="drawer-btn"
              onClick={() => {
                setIsDrawerOpen(!isDrawerOpen);
              }}
            >
              <img
                alt={isDrawerOpen ? '접기' : '펼치기'}
                src={
                  isDrawerOpen
                    ? 'https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-arrow-up.png'
                    : 'https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-arrow-down.png'
                }
              />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ContentsPreviewMobile;
